"use client";

import React from "react";
import FormFieldWrapper from "./formFieldWrapper";
import { NavigationTabs } from "../common/navigationTabs";
import DiscountCode from "./discountCode";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setCurrentTab } from "@/store/slices/discount.slice";
import { PageType, TabType } from "@/types/coupon/discount";

const DiscountMethodSection = ({ currentPage }: { currentPage: PageType }) => {
  const dispatch = useAppDispatch();

  const currentTab = useAppSelector((state) => state.discount.currentTab);
  const handleTabClick = (tab: TabType) => {
    dispatch(setCurrentTab(tab));
  };
  return (
    <FormFieldWrapper title="Method">
      <NavigationTabs
        tabs={[
          {
            label: "Discount Code",
            onClick: () => {
              handleTabClick("code");
            },
            isActive: currentTab === "code",
          },
          {
            label: "Automatic Discount",
            onClick: () => {
              handleTabClick("automatic");
            },
            isActive: currentTab === "automatic",
          },
        ]}
        hasBackButton={false}
      />
      <DiscountCode currentPage={currentPage} currentTab={currentTab} />
    </FormFieldWrapper>
  );
};

export default DiscountMethodSection;
